var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "modify-detail__actions" }, [
    _vm.showIataMessage
      ? _c("div", { staticClass: "modify-detail__actions-block" }, [
          _c("div", { staticClass: "modify-detail__actions-iata-alert" }, [
            _c("span", { staticClass: "icon-warning" }),
            _vm._v(" "),
            _c("span", [
              _vm._v("\n        " + _vm._s(_vm.iataMessage) + "\n      "),
            ]),
          ]),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.showModifyActionSidebarBlock
      ? _c("div", { staticClass: "modify-detail__actions-block" }, [
          _c("div", { staticClass: "modify-detail__actions-title" }, [
            _vm._v("\n      " + _vm._s(_vm.ModifyReservationTitle) + "\n    "),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "modify-detail__actions-button" },
            [
              _c("modify-edit-modal", {
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (ref) {
                        var activate = ref.activate
                        return _c("div", {}, [
                          _c(
                            "button",
                            {
                              staticClass:
                                "button--secondary black size-md outlined",
                              on: {
                                click: activate,
                                keydown: [
                                  function ($event) {
                                    if (
                                      !$event.type.indexOf("key") &&
                                      _vm._k(
                                        $event.keyCode,
                                        "space",
                                        32,
                                        $event.key,
                                        [" ", "Spacebar"]
                                      )
                                    ) {
                                      return null
                                    }
                                    $event.preventDefault()
                                    return activate($event)
                                  },
                                  function ($event) {
                                    if (
                                      !$event.type.indexOf("key") &&
                                      _vm._k(
                                        $event.keyCode,
                                        "enter",
                                        13,
                                        $event.key,
                                        "Enter"
                                      )
                                    ) {
                                      return null
                                    }
                                    $event.preventDefault()
                                    return activate($event)
                                  },
                                ],
                              },
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.ModifyReservationCTALabel) +
                                  "\n          "
                              ),
                            ]
                          ),
                        ])
                      },
                    },
                  ],
                  null,
                  false,
                  3214921796
                ),
              }),
            ],
            1
          ),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "modify-detail__actions-block" },
      [
        _vm.showCancelActionSidebarBlock
          ? _c("div", { staticClass: "modify-detail__actions-title" }, [
              _vm._v(
                "\n      " + _vm._s(_vm.CancelReservationTitle) + "\n    "
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.showCancelActionSidebarBlock
          ? _c(
              "div",
              { staticClass: "modify-detail__actions-button" },
              [
                _c("modify-cancel-modal", {
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (ref) {
                          var activate = ref.activate
                          return _c("div", {}, [
                            _c(
                              "button",
                              {
                                staticClass:
                                  "button--secondary black size-md outlined",
                                on: {
                                  click: activate,
                                  keydown: [
                                    function ($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "space",
                                          32,
                                          $event.key,
                                          [" ", "Spacebar"]
                                        )
                                      ) {
                                        return null
                                      }
                                      $event.preventDefault()
                                      return activate($event)
                                    },
                                    function ($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      ) {
                                        return null
                                      }
                                      $event.preventDefault()
                                      return activate($event)
                                    },
                                  ],
                                },
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(_vm.CancelReservationCTALabel) +
                                    "\n          "
                                ),
                              ]
                            ),
                          ])
                        },
                      },
                    ],
                    null,
                    false,
                    950652978
                  ),
                }),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _c("toggle-details", {
          attrs: {
            "data-open-on-init": _vm.openCancelPolicyToggleOnInit
              ? "true"
              : "false",
          },
          scopedSlots: _vm._u([
            {
              key: "default",
              fn: function (ref) {
                var opened = ref.opened
                var toggle = ref.toggle
                var isMounted = ref.isMounted
                return _c("div", {}, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "modify-detail__actions-cancellation-policy-wrapper",
                      class: [
                        { opened: opened },
                        { "no-divider": _vm.openCancelPolicyToggleOnInit },
                        { divider: !_vm.openCancelPolicyToggleOnInit },
                        { "no-margin-top": !_vm.showCancelActionSidebarBlock },
                      ],
                    },
                    [
                      _c("div", { staticClass: "activator" }, [
                        _vm.openCancelPolicyToggleOnInit
                          ? _c("div", [
                              _c(
                                "div",
                                {
                                  class:
                                    "policy-block " +
                                    (_vm.openCancelPolicyToggleOnInit
                                      ? "disable"
                                      : "") +
                                    " ",
                                },
                                [
                                  _c("div", { staticClass: "policy-title" }, [
                                    !_vm.isMultiRoomReservation
                                      ? _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.cancelReservationPolicyLabelSingular
                                            )
                                          ),
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.isMultiRoomReservation
                                      ? _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.cancelReservationPolicyLabelPlural
                                            )
                                          ),
                                        ])
                                      : _vm._e(),
                                  ]),
                                ]
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        !_vm.openCancelPolicyToggleOnInit
                          ? _c(
                              "div",
                              {
                                attrs: {
                                  role: "button",
                                  tabindex: "0",
                                  "aria-expanded": opened ? "true" : "false",
                                },
                                on: {
                                  click: toggle,
                                  keydown: [
                                    function ($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      ) {
                                        return null
                                      }
                                      $event.preventDefault()
                                      return toggle($event)
                                    },
                                    function ($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "space",
                                          32,
                                          $event.key,
                                          [" ", "Spacebar"]
                                        )
                                      ) {
                                        return null
                                      }
                                      $event.preventDefault()
                                      return toggle($event)
                                    },
                                  ],
                                },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    class:
                                      "policy-block " +
                                      (_vm.openCancelPolicyToggleOnInit
                                        ? "disable"
                                        : "") +
                                      " ",
                                  },
                                  [
                                    _c("div", { staticClass: "policy-title" }, [
                                      !_vm.isMultiRoomReservation
                                        ? _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.cancelReservationPolicyLabelSingular
                                              )
                                            ),
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.isMultiRoomReservation
                                        ? _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.cancelReservationPolicyLabelPlural
                                              )
                                            ),
                                          ])
                                        : _vm._e(),
                                    ]),
                                    _vm._v(" "),
                                    _c("div", {
                                      class: opened ? "icon-minus" : "icon-add",
                                    }),
                                  ]
                                ),
                              ]
                            )
                          : _vm._e(),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "policy-list",
                          class: [
                            { opened: opened },
                            { "no-margin-top": !_vm.isMultiRoomReservation },
                          ],
                        },
                        [
                          _c(
                            "transition-group",
                            { attrs: { name: "expand-y" } },
                            [
                              opened
                                ? _c(
                                    "div",
                                    { key: "cancellation-policy__list" },
                                    _vm._l(
                                      _vm.currentReservationData.reservations,
                                      function (reservation) {
                                        return _c(
                                          "div",
                                          {
                                            key: reservation.id,
                                            staticClass: "policy-item",
                                            class: [
                                              {
                                                single:
                                                  !_vm.isMultiRoomReservation,
                                              },
                                            ],
                                          },
                                          [
                                            _vm.isMultiRoomReservation
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "policy-room-label",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                    " +
                                                        _vm._s(
                                                          _vm.ModifyReservationRoomTitle
                                                        ) +
                                                        " " +
                                                        _vm._s(
                                                          reservation.roomNumberOrder
                                                        ) +
                                                        ":\n                    " +
                                                        _vm._s(
                                                          reservation
                                                            .roomStays[0]
                                                            .roomName
                                                        ) +
                                                        "\n                  "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _c("ul", {
                                              staticClass:
                                                "policy-description list-indent",
                                              domProps: {
                                                innerHTML: _vm._s(
                                                  _vm.renderCancelPenaltiesText(
                                                    reservation.cancelPenaltiesText
                                                  )
                                                ),
                                              },
                                            }),
                                          ]
                                        )
                                      }
                                    ),
                                    0
                                  )
                                : _vm._e(),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                ])
              },
            },
          ]),
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "modify-detail__actions-block" }, [
      _c("div", { staticClass: "modify-detail__actions-question" }, [
        _vm._v("\n      " + _vm._s(_vm.QuestionTitle) + "\n    "),
      ]),
      _vm._v(" "),
      _c("ul", { staticClass: "modify-detail__actions-text list-indent" }, [
        _vm.currentReservationData.property.liveChat !== ""
          ? _c("li", { staticClass: "live-chat" }, [
              _c(
                "a",
                {
                  attrs: {
                    target: "_blank",
                    href: _vm.currentReservationData.property.liveChat,
                  },
                },
                [_vm._v(_vm._s(_vm.QuestionLiveChatTitle))]
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.currentReservationData.property.phone !== ""
          ? _c("li", { staticClass: "phone" }, [
              _vm._v("\n        " + _vm._s(_vm.QuestionPhoneTitle) + " "),
              _c(
                "a",
                {
                  attrs: {
                    href: "tel:" + _vm.currentReservationData.property.phone,
                  },
                },
                [_vm._v(_vm._s(_vm.currentReservationData.property.phone))]
              ),
            ])
          : _vm._e(),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }